import React from 'react';
import * as Bootstrap from 'react-bootstrap';
import PropTypes from 'prop-types';
import './samsungmodal.scss';
import closeIco from '../../images/bdp/close.svg';

function SamsungModalPopup(props) {
  const closeDialog = () => {
    props.onClose();
  }

    return (
      <Bootstrap.Modal
        size={props.size || 'lg'}
        show={props.show}
        keyboard={false}
        backdrop="static"
        centered
      >
        <Bootstrap.ModalBody>
          {!props.hideCloseBtn && (
            <div className='popupContainer'>
                <h1 className='popupHeading'>{props.heading}</h1>
                <span className='close' onClick={() => closeDialog()}>
                <img alt="close" src={closeIco} />
                </span>
            </div>
          )}
          {props.children}
        </Bootstrap.ModalBody>
      </Bootstrap.Modal>
    );
}

SamsungModalPopup.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func,
  show: PropTypes.bool,
  heading: PropTypes.string,
  hideCloseBtn: PropTypes.bool,
  size: PropTypes.string,
};

SamsungModalPopup.defaultProps = {
  onClose: () => {},
  show: false,
  heading: '',
  size: 'lg',
  hideCloseBtn: false,
};

export default SamsungModalPopup;
